module.exports = __webpack_public_path__ + "img/instagram.63e43467.png";